import { render, staticRenderFns } from "./CustomWellnessTemplateBuilder.vue?vue&type=template&id=6132c5ab&scoped=true&lang=pug&"
import script from "./CustomWellnessTemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./CustomWellnessTemplateBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132c5ab",
  null
  
)

export default component.exports